import { Box, Button, Container, Grid, Link, Typography } from '@mui/material'
import { FixedLogo, Icon, Page } from 'components'
import { theme } from 'config'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Pages } from 'routes'
import { AuthStore, RoutingStore } from 'stores'

export interface IBankIDLoginProps {
  authStore?:    AuthStore,
  routingStore?: RoutingStore,
}

export const BankIDLogin = inject('authStore', 'routingStore')(observer((props: IBankIDLoginProps) => {
  const { t } = useTranslation();
  const { authStore, routingStore } = props;

  React.useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const grandidsession = urlParams.get('grandidsession');
    if (grandidsession) {
      authStore.validateBankIdLoginCallback(grandidsession);
      const url = new URL(window.location.href);
      url.searchParams.delete('grandidsession');
      window.history.replaceState({}, '', url);
    }
  }, []);

  React.useEffect(() => {
    if (authStore.getCurUserType) {
      // TODO Check history if this was a re-route and route accordingly
      routingStore.push(RoutingStore.startPage[authStore.getCurUserType]);
    }
  }, [props.authStore.getCurUser]);

  return (
    <Page isLoading={authStore.isAuthenticating}>
      <Container maxWidth='sm'>
        <FixedLogo />
        <Grid
          container
          direction      = 'column'
          alignItems     = 'center'
          justifyContent = 'center'
          width          = '100%'
          sx             = {{ minHeight: '100vh' }}
        >
          <Grid item xs={12}>
            <Typography variant='h2' textAlign='center'>
              {t('login_to_your_account')}
            </Typography>
            <Box>
              <Typography textAlign='center' color='red'>
                {t(props.authStore.error_message)}
              </Typography>
            </Box>
            <Box
              display       = 'flex'
              flexDirection = 'column'
              alignItems    = 'center'
              width         = '100%'
              gap           = {1}
              mt            = {5}
            >
              <Button
                fullWidth
                variant = 'contained'
                onClick = {() => props.authStore.signInBankID()}
              >
                <Icon iconId='bank-id' size={'size-36'} />
                <Typography
                  variant    = 'body2'
                  ml         = {3}
                  textAlign  = 'center'
                  fontWeight = '600'
                >
                  {t('login_width_bank_id')}
                </Typography>
              </Button>
              <Typography variant='body2' mt={4} textAlign='left'>
                <Trans
                  t          = {t}
                  i18nKey    = 'email_login'
                  components = {[
                    <Link
                      key        = 'email_login'
                      underline  = 'hover'
                      color      = {theme.palette.green.light}
                      fontWeight = {theme.typography.fontWeightBold}
                      onClick    = {() => routingStore.push(Pages.Login)}
                    />
                  ]}
                />
              </Typography>
              <Typography variant='body2' mt={4} textAlign='left'>
                <Trans
                  t          = {t}
                  i18nKey    = 'integrity_policy'
                  components = {[
                    <Link
                      key        = 'policy'
                      underline  = 'hover'
                      color      = {theme.palette.green.light}
                      fontWeight = {theme.typography.fontWeightBold}
                      href       = 'https://www.blendow.se/om/integritetsskyddspolicy/'
                    />,
                    <Link
                      key        = 'mailto'
                      underline  = 'hover'
                      sx         = {{ cursor: 'pointer' }}
                      color      = {theme.palette.green.light}
                      fontWeight = {theme.typography.fontWeightBold}
                      onClick    = {() => {
                        window.location.href =
                          'mailto: support@bginstitute.se'
                      }}
                    />,
                  ]}
                />
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}));
